import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { Location, LocationFilters } from '../../models/Location';

const useLocationService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetLocations, setFetchingGetLocations] = useState(false);
    const [fetchingCreateLocation, setFetchingCreateLocation] = useState(false);
    const [fetchingStoreLocation, setFetchingStoreLocation] = useState(false);
    const [fetchingEditLocation, setFetchingEditLocation] = useState(false);
    const [fetchingUpdateLocation, setFetchingUpdateLocation] = useState(false);
    const [fetchingDeleteLocation, setFetchingDeleteLocation] = useState(false);
    const [fetchingActiveLocation, setFetchingActiveLocation] = useState(false);

    const getLocations = (filters: LocationFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== undefined && value !== '' && value !== null)
            .map(([key, value]) => {
                // Convertir booleanos a strings que el backend entienda
                if (typeof value === 'boolean') {
                    return `${key}=${value ? 'true' : 'false'}`;
                }
                return `${key}=${value}`;
            })
            .join('&');

        const url = `${EndPoints.LOCATIONS.GET_LOCATIONS}${queryString ? '?' + queryString : ''}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetLocations
        });
    };

    const createLocation = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.LOCATIONS.GET_LOCATIONS,
            setFetching: setFetchingCreateLocation
        });
    };

    const storeLocation = (location: Location, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.LOCATIONS.STORE_LOCATION,
            body: location,
            setFetching: setFetchingStoreLocation
        });
    };

    const editLocation = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.LOCATIONS.EDIT_LOCATION.replace(':id', id.toString()),
            setFetching: setFetchingEditLocation
        });
    };

    const updateLocation = (id: number, location: Location, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.LOCATIONS.UPDATE_LOCATION.replace(':id', id.toString()),
            body: location,
            setFetching: setFetchingUpdateLocation
        });
    };

    const deleteLocation = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.LOCATIONS.DELETE_LOCATION.replace(':id', id.toString()),
            setFetching: setFetchingDeleteLocation
        });
    };

    const activeLocation = (id: number, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.LOCATIONS.ACTIVE_LOCATION.replace(':id', id.toString()),
            setFetching: setFetchingActiveLocation
        });
    };

    return {
        // states
        fetchingGetLocations,
        fetchingCreateLocation,
        fetchingStoreLocation,
        fetchingEditLocation,
        fetchingUpdateLocation,
        fetchingDeleteLocation,
        fetchingActiveLocation,
        // methods
        getLocations,
        createLocation,
        storeLocation,
        editLocation,
        updateLocation,
        deleteLocation,
        activeLocation
    };
};

export default useLocationService;
